import React from 'react';
import CourseProgressWidget from './dashboard/CourseProgressWidget';
import CommunityActivityWidget from './dashboard/CommunityActivityWidget';
import AISuggestionsWidget from './dashboard/AISuggestionsWidget';
import UpcomingEventsWidget from './dashboard/UpcomingEventsWidget';
import StatsWidget from './dashboard/StatsWidget';
const Dashboard = () => {
  return <div className="space-y-4" data-id="element-1121">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1122">
        <div className="col-span-1 md:col-span-2" data-id="element-1123">
          <CourseProgressWidget data-id="element-1124" />
          <div className="mt-4" data-id="element-1125">
            <StatsWidget data-id="element-1126" />
          </div>
          <div className="mt-4" data-id="element-1127">
            <UpcomingEventsWidget data-id="element-1128" />
          </div>
        </div>
        <div className="col-span-1" data-id="element-1129">
          <AISuggestionsWidget data-id="element-1130" />
        </div>
      </div>
    </div>;
};
export default Dashboard;